import { Stack } from "@bps/fluent-ui";
import { ContactType } from "@libs/gateways/practice/PracticeGateway.dtos.ts";

import { QuickAddAddressFields } from "./QuickAddAddressFields.tsx";
import { QuickAddContactBasicFormFields } from "./QuickAddContactBasicFormFields.tsx";
import { QuickAddOrgContactFormFields } from "./QuickAddOrgContactFormFields.tsx";

interface QuickAddContactFormFieldsProps {
  contactType: string;
  detailedView?: boolean;
}

export const QuickAddContactFormFields: React.FunctionComponent<
  QuickAddContactFormFieldsProps
> = ({ contactType, detailedView }) => {
  return (
    <Stack tokens={{ childrenGap: 8 }}>
      {contactType === ContactType.Organisation ? (
        <QuickAddOrgContactFormFields />
      ) : (
        <>
          <QuickAddContactBasicFormFields detailedView={detailedView} />
          {detailedView && contactType === ContactType.Individual && (
            <QuickAddAddressFields />
          )}
        </>
      )}
    </Stack>
  );
};
